var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-item"},[_c('router-link',{attrs:{"tag":"li","to":_vm.href,"active-class":"active","exact":""}},[_c('a',{attrs:{"href":_vm.href}},[_c('p',{on:{"click":function($event){return _vm.$emit("click")}}},[_c('span',{class:_vm.icon}),_vm._v(" \n"+_vm._s(_vm.title))])])]),_c('div',{staticClass:"subnav"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7134b98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/item.vue
// module id = mEnS
// module chunks = 12